import clsx from "clsx";
import getColorClassByDistance from "@/domains/chat/helpers/getColorClassByDistance";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatWhisperMessage({ message, settings }: MessageProps) {
  const { showTime, messageHeader } = settings;

  return (
    <div className={clsx("overflow-clip w-full", getColorClassByDistance(20))}>
      <div className={clsx({ inline: !messageHeader })}>
        {showTime && <Time date={message.date} />} <span>{getPlayerContent(message)}</span> шепнул
        {": "}
      </div>
      <div className={clsx("font-medium", { inline: !messageHeader })}>
        {message.message.content}
      </div>
    </div>
  );
}
